export enum InputWidth {
    Time = 65,
    Numeric = 50,
    Currency = 90,
    Date = 90,
    ToolbarDate = 145,
    ToolbarDateWithoutLabel = 110,
    ToolbarSelect = 250,
    ToolbarSelectXL = 320,
}
